import React from 'react';
import { translate } from 'react-i18next';
import CBMediaQuery from '../shared/CBMediaQuery';
import { getStyle, SERVICE_FLEET } from '../../utils/utils';
import NotificationCardHeader from './NotificationCardHeader';
import NotificationToggleRow from './NotificationToggleRow';
import { styles } from './notificationSettingsStyles';

// One opt-out switch per chain for every chain-only e-mail. Fleet customers see
// it as "Ketjun viestit"; inside the chain it is "Ketjun sisäinen viestintä".
const NotificationChainCard = ({
  t, chains, service, onToggle, disabled,
}) => {
  const isFleet = service === SERVICE_FLEET;
  return (
    <CBMediaQuery>
      {screenSize => (
        <div style={getStyle(screenSize, styles, 'card')} data-testid='chain-card'>
          <NotificationCardHeader
            icon='pi pi-comments'
            title={isFleet ? t('chainFleetTitle') : t('chainTitle')}
            description={isFleet ? t('chainFleetDescription') : t('chainDescription')}
          />
          {chains.map((chain, index) => (
            <NotificationToggleRow
              key={chain.id}
              first={index === 0}
              testId={`chain-switch-${chain.id}`}
              label={chain.name}
              hint={t('chainSwitchHint')}
              checked={chain.enabled}
              disabled={disabled}
              onChange={checked => onToggle('chain', chain.id, checked)}
            />
          ))}
        </div>
      )}
    </CBMediaQuery>
  );
};

export default translate('NotificationSettings')(NotificationChainCard);
